import { creatorbase, influencer, InstagramUser, InstagramUserStatsCache } from '@round/api';
import { getInstagramEngagementRate } from '../../../Posts/helpers';
import { Row, Totals } from './InstagramReportClipboardTable';
import { isNumber } from 'utility/utility';

const getPostStats = (post: creatorbase.InstagramPost | creatorbase.PublicInstagramPost) => {
    return {
        cost: post.cost,
        views:
            post.view_count || post.instagram_details?.story_view_count
                ? (post.view_count ?? 0) + (post.instagram_details?.story_view_count ?? 0)
                : null,
        likes: post.instagram_details?.like_count,
        comments: post.instagram_details?.comment_count,
        engagementRate: getInstagramEngagementRate(post),
    };
};

type MapToClipboardReportRowParams = {
    post: creatorbase.InstagramPost | creatorbase.PublicInstagramPost;
    user?: InstagramUser | null;
    userStats?: InstagramUserStatsCache | null;
};

export const mapToClipboardReportRow = ({ post, user, userStats }: MapToClipboardReportRowParams): Row => {
    const stats = getPostStats(post);
    return {
        status: post.status,
        username: user?.username,
        followers: userStats?.follower_count,
        link: post.post_url,
        uploadDate: post.upload_date,
        ...stats,
    };
};

export const mapToClipboardReportTotals = (
    stats: creatorbase.AggregatedPostStats | influencer.AggregatedPostStats | null,
    rows: Row[],
    campaign?: creatorbase.InstagramCampaign
): Totals => {
    const comments = rows.reduce((acc, row) => acc + (row.comments ?? 0), 0);
    const likes = rows.reduce((acc, row) => acc + (row.likes ?? 0), 0);
    const cost = rows.reduce((acc, row) => acc + (row.cost ?? 0), 0);

    return {
        comments,
        likes,
        engagementRate: stats?.engagement_rate,
        views: stats?.view_count,
        cost: !campaign?.is_post_cost_editable && isNumber(campaign?.cost) ? campaign?.cost : cost,
    };
};
